export default __webpack_public_path__ + "static/media/Vector 7.ac97a8fe.svg";